<template>
  <div id="faq" class="container">
    <div class="row">
      <div class="col-12">
        <h2>FAQ</h2>
      </div>
    </div>
    <div class="row" v-if="!admin">
      <div class="col-12 question-container" v-for="q in questions" v-bind:key="q.question">
        <div class="question">
          {{q.question}}
        </div>
        <div class="answer" v-html="q.answer">
        </div>
      </div>
    </div>
    <div class="row" v-if="admin">
      <div class="saving" v-if="saving">
        <p>{{saving}}</p>
      </div>
      <div class="confirm-delete" v-if="confirmDelete">
        <p>Are you sure you want to delete:</p>
        <p>{{confirmDelete.question}}</p>
        <div class="action">
          <button class="confirm" @click="deleteFAQ()">Do it</button>
          <button class="cancel" @click="confirmDelete = null">Nah</button>
        </div>
      </div>
      <div class="col-12 question-container" v-for="q in questions" v-bind:key="q.i">
        <div class="question">
          <textarea class="q" type="text" :rows="q.question.length / 20" v-model="q.question"></textarea>
        </div>
        <div class="answer">
          <textarea class="a" type="text" :rows="q.answer.length / 30" v-model="q.answer"></textarea>
        </div>
        <div class="action">
          <button @click="moveUpOne(q)">
            <font-awesome-icon :icon="['fa', 'chevron-up']" />
          </button>
          {{q.order}}
          <button @click="moveDownOne(q)">
            <font-awesome-icon :icon="['fa', 'chevron-down']" />
          </button>
          <button @click="save(q)">SAVE</button>
          <button class="delete-faq" @click="confirmDelete=q"><font-awesome-icon :icon="['fa', 'trash-alt']" /></button>
        </div>
      </div>
      <div class="col-12 question-container new">
        <div class="question">
          {{newQuestion}}
          <textarea placeholder="New Question" class="q" type="text" :rows="newQuestion.length / 20" v-model="newQuestion"></textarea>
        </div>
        <div class="answer">
          <textarea placeholder="Obvi Answer" class="a" type="text" :rows="newAnswer.length / 30" v-model="newAnswer"></textarea>
        </div>
        <div class="action">
          <button class="button" @click="addFAQ()">Add FAQ</button></div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from './mixins/HelperFunctions.js'
import {faqsRef} from '../firebase/firebaseConfig.js'

export default {
  mixins: [Mixin],
  name: 'FAQ',
  props: {},
  mounted() {
    faqsRef.orderBy('order').onSnapshot((faqR) => {
      let localCopy = []
      faqR.forEach((doc) => {
        const faq = doc.data()
        faq.uuid = doc.id
        localCopy.push(faq)
      })
      this.questions = localCopy
    })
  },
  data: function (){
    return {
      saving: false,
      confirmDelete: false,
      newQuestion: '',
      newAnswer: '',
      questions: []
    }
  },
  methods: {
    save(q) {
      let vm = this
      vm.saving = 'saving your typos...'
      faqsRef.doc(q.uuid).update(
        {...q}
      ).then(function() {
        vm.saving = false
      }).catch(function(error) {
        console.log('error2', error)
      })
    },
    moveUpOne(q) {
      if (q.order > 1) {
        let vm = this
        vm.saving = 'movin on up..'
        let oldOne = this.questions[q.order-2]
        faqsRef.doc(q.uuid).update(
          {order: q.order-1}
        ).then(function() {
          faqsRef.doc(oldOne.uuid).update(
            {order: q.order}
          ).then(function() {
            vm.saving = false
          }).catch(function(error) {
            console.log('error2', error)
          })
        }).catch(function(error) {
          console.log('error2', error)
        })
      }
    },
    moveDownOne(q) {
      if (q.order < this.questions.length) {
        let vm = this
        vm.saving = 'goin downtown..'
        let oldOne = this.questions[q.order]
        faqsRef.doc(q.uuid).update(
          {order: q.order + 1}
        ).then(function() {
          faqsRef.doc(oldOne.uuid).update(
            {order: q.order}
          ).then(function() {
            vm.saving = false
          }).catch(function(error) {
            console.log('error2', error)
          })
        }).catch(function(error) {
          console.log('error2', error)
        })
      }
    },
    addFAQ() {
      let vm = this
      vm.saving = 'Urgh another dumb question...'
      faqsRef.add({
        question: vm.newQuestion,
        answer: vm.newAnswer,
        order: vm.questions.length + 1
      }).then(() => {
        vm.newQuestion = ''
        vm.newAnswer = ''
        vm.saving = false
      });
    },
    // confirmDelete(f) {
    //
    // },
    deleteFAQ() {
      let vm = this
      let cd = {...vm.confirmDelete}
      vm.confirmDelete = null
      vm.saving = 'Bai dumb question'
      faqsRef.doc(cd.uuid).delete().then(function() {
        vm.saving = false
      }).catch(function(error) {
          console.error("Error removing document: ", error);
      });
    }
  },
  computed: {
    admin() {
      if (this.user) {
        return Object.keys(this.user).length > 0
      } else {
        return false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#faq {
  // max-width: 300px;
  // margin: auto;
  h2 {
    // text-align: center;
  }
  text-align: left;
  .question-container {
    // margin: 20px auto;
    &.new {
      background: $oroGold;
      border-radius: 5px;
      margin-bottom: 30px;
      .question {
        background: $oroGray;
        border: 2px solid $oroGold;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      }
      textarea {
        width: 100%;
        &.q {
          background: $oroGray;
          color: $oroGold;
          font-weight: bold;
        }
        &.a {
          color: $oroGray;
          background: $oroGold;
        }
        background: none;
        border: none;
      }
    }

    textarea {
      width: 100%;
      &.q {
        color: $oroGray;
        font-weight: bold;
      }
      &.a {
        color: $oroGold;
      }
      background: none;
      border: none;
    }
    .question {
      background: #e9c46a;
      color: #264653;
      font-weight: bold;
      font-size: 18px;
      padding: 5px 10px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    .answer {
      padding: 15px 10px;
      border: 2px solid #e9c46a;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    .action {
      color: $oroGray;
      position: relative;
      top: -5px;
      background: $oroGold;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      button {
        font-weight: bold;
        height: 30px;
        min-width: 50px;
        background: $oroGray;
        color: $oroGold;
        margin: 5px;
        border: 2px solid $oroGray;
        border-radius: 4px;
      }
    }
  }
  input {
    background: none;
  }
  .delete-faq {
    float: right;
  }

  .saving, .confirm-delete {
    width: 90%;
    position: fixed;
    z-index: 100;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    background: white;
    height: 100px;
    border: 2px solid black;
    border-radius: 5px;
    p {
      height: 100%;
      font-size: 20px;
      color: $oroGray;
      text-align: center;
      font-weight: bold;
      padding: 0;
      margin: 20px auto;
    }
  }
  .confirm-delete {
    height: 400px;
    text-align: center;
    .action {
      color: $oroGray;
      position: relative;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      margin: 20px auto;
      button {
        font-weight: bold;
        height: 60px;
        min-width: 40%;
        background: $oroGray;
        color: $oroGold;
        margin: 5px;
        border-radius: 4px;
        font-size: 24px;
        &.confirm {
          border: 2px solid $oroGray;
          background: $oroGold;
          color: $oroGray;
        }
        &.cancel {
          border: 2px solid $oroGray;
          background: $oroGray;
          color: white;
        }
      }
    }
    p {
      width: 80%;
      font-size: 18px;
      height: auto;
    }
  }
}

a.venmo {
  color: white !important;
  text-decoration: none;
}
</style>
